import type { AnalyticsAction, AnalyticsObject, AnalyticsEvent } from '../types'

export const aggregateProperties = (
  mainObject: AnalyticsObject,
  ...additionalObjects: Array<AnalyticsObject | undefined>
): AnalyticsObject => {
  const properties = additionalObjects.reduce(
    (properties, addObj) => ({ ...addObj?.properties, ...properties }),
    { ...mainObject.properties },
  )
  return { ...mainObject, properties }
}

export function analytics(action: AnalyticsAction, object: AnalyticsObject): AnalyticsEvent {
  return { action, object }
}
